import React, {useCallback, useState} from 'react';
import Button from './Button';
import {sendVoucher} from "../../services/send-voucher-service";
import iconLoading from "../../../images/spinner.svg";
import errorVoucher from "../../../images/email-error.png";
import voucherSend from "../../../images/email-send.png";
import {FormattedMessage} from "react-intl";

type Props = {
  className: string;
  transactionId: string;
};

const ButtonTryAgain = ({ className, transactionId }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  const handleButton = useCallback(() => {
    setIsLoading(true);
    setIsError(false);
    sendVoucher(transactionId).then(r => {
      setIsLoading(false);
      setIsComplete(true);
    })
        .catch((error: Error | unknown) => {
          setIsLoading(false);
          setIsError(true);
          setIsComplete(true);
        });
  }, []);

  return (
    <Button
      name="send_voucher"
      className={`${className} ${isError ? 'disabled-button-error' : isComplete ? 'disabled-button' : ''}`}
      onClick={handleButton}
      text={isLoading ? (
          <img src={iconLoading} className="spinner" alt={'icon loading'}/>
      ) : isError ? (
          <>
              <img src={errorVoucher} className="error-voucher" alt="error icon" />
              <FormattedMessage id="formData.errorSendingVoucher" />
          </>
      ) : isComplete? (
          <>
              <img src={voucherSend} className="send-voucher" alt="send icon" />
              <FormattedMessage id="formData.completeSendVoucher" />
          </>
      ): (<FormattedMessage id="formData.sendVoucherButton" />)}
      disabled={isComplete}
      type={'button'}
    />
  );
};

export default ButtonTryAgain;
